import { Injectable } from '@angular/core';
import { UserRole } from '../enum/user-role';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private rolesMap: Map<number, UserRole> = new Map<number, UserRole>();

  constructor() {
    this.rolesMap.set(1, UserRole.SITE);
    this.rolesMap.set(2, UserRole.CER);
    this.rolesMap.set(3, UserRole.ADMIN);
    this.rolesMap.set(4, UserRole.INTRAPRESA);
  }

  getRoleById(id: number): UserRole | undefined {
    return this.rolesMap.get(id);
  }

  getUserRole(role?: string): UserRole {
    switch (role) {
      case 'Admin':
        return UserRole.ADMIN;
      case 'Cer':
        return UserRole.CER;
      case 'Intrapresa':
        return UserRole.INTRAPRESA;
      case 'Sito':
        return UserRole.SITE;
      default:
        return UserRole.SITE;
    }
  }
}
